import axios from "axios";
import React, { useEffect, useState } from "react";
import { useUserType } from "../UserTypeContext";
import { FaAngleDown } from "react-icons/fa";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { AmbikaVenderApi } from "../config";

const AddTocart = () => {
  const [cartDataDate, setCartDataDate] = useState();
  const [cartData, setCartData] = useState();
  const [selectRoute, setSelectRoute] = useState();
  const [startDate, setStartDate] = useState(null);
  const { userType, setUserType } = useUserType();
  const [quantity, setQuantity] = useState();
  const [price, setPrice] = useState();
  const [totalPrice, setTotalPrice] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [postData, setPostData] = useState();
  const [checkNumber, setCheckNumber] = useState("");
  const [addCustomer, setAddCustomer] = useState(false);
  const [addCustomerName, setAddCustomerName] = useState("");
  const [addCustomerButton, setAddCustomerButton] = useState(false);
  const [addSelectRoute, setAddSelectRoute] = useState("");
  const [cartId, setCartId] = useState();
  const [profile, setProfile] = useState();
  const [branchDetails, setBranchDetails] = useState();
  const [currentTime, setCurrentTime] = useState();
  const [minDate, setMinDate] = useState("");
  const [completeTime, setCompleteTime] = useState();
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const ambikaUserToken = localStorage.getItem("ambikaUserToken");
  const ambikaUserId = localStorage.getItem("ambikaUserId");
  const ambikaCustomerId = localStorage.getItem("ambikaCustomerId");

  const navigate = useNavigate();

  // Validation function
  const validateForm = () => {
    const newErrors = {};

    // Delivery date validation
    if (!startDate) {
      newErrors.startDate = "Delivery date is required";
    }

    // Route validation
    if (!addSelectRoute) {
      newErrors.addSelectRoute = "Route selection is required";
    }

    // Customer validation for Customer type
    if (userType === "Customer") {
      if (!checkNumber || checkNumber.length < 10) {
        newErrors.checkNumber = "Valid 10-digit mobile number is required";
      }
      if (!addCustomerName || addCustomerName.trim() === "") {
        newErrors.addCustomerName = "Customer name is required";
      }
      if (!paymentType) {
        newErrors.paymentType = "Payment method is required";
      }
      if (
        typeof postData?.PaidAmount === "undefined" ||
        postData?.PaidAmount === ""
      ) {
        newErrors.paidAmount = "Paid amount is required";
      } else {
        const advancePercentage = parseFloat(profile?.advance_order_amount_percentage);
        if (!isNaN(advancePercentage) && advancePercentage > 0) {
          const minRequiredAmount = (totalPrice * advancePercentage) / 100;
          if (Number(postData?.PaidAmount) < minRequiredAmount) {
            newErrors.paidAmount = `Minimum paid amount must be ${advancePercentage}% (₹${Math.round(minRequiredAmount)})`;
          }
        }
      }
      if (!postData?.PaymentRemarks || postData?.PaymentRemarks.trim() === "") {
        newErrors.paymentRemarks = "Payment remark is required";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    axios
      .post(
        `${AmbikaVenderApi}/vendor/branchDetail`,
        { UserId: ambikaUserId },
        { headers: { Authorization: `Bearer ${ambikaUserToken}` } }
      )
      .then((res) => {
        setBranchDetails(res?.data?.data);
      })
      .catch((err) => {
        console.error("Error fetching branch details:", err);
      });
  }, [ambikaUserId]);

  useEffect(() => {
    axios
      .get(`https://www.erp.ambikadairyfarm.com/api/vendor/profile`, {
        headers: { Authorization: `Bearer ${ambikaUserToken}` },
      })
      .then((res) => {
        setProfile(res?.data?.data);
      })
      .catch((err) => {
        console.error("Error fetching profile:", err);
      });
  }, [ambikaUserToken, ambikaUserId]);

  const getCartDetails = () => {
    axios
      .post(
        `https://www.erp.ambikadairyfarm.com/api/vendor/cartProductList`,
        { UserId: ambikaUserId, CartType: userType },
        { headers: { Authorization: `Bearer ${ambikaUserToken}` } }
      )
      .then((res) => {
        setCartData(res?.data?.data);
        setQuantity(res?.data?.data?.map((el) => el?.product_qty));
        setPrice(res?.data?.data?.map((el) => el?.product_price));
        setCartId(res?.data?.data?.map((el) => el?.id));
        setCartDataDate(res?.data?.same_day_pickup);
      })
      .catch((err) => {
        console.error("Error fetching cart details:", err);
      });
  };

  useEffect(() => {
    getCartDetails();
  }, [userType, ambikaUserId, ambikaUserToken]);

  const handelDeletProduct = (cartId) => {
    axios
      .post(
        `https://www.erp.ambikadairyfarm.com/api/vendor/removeCartProduct`,
        { UserId: ambikaUserId, CartId: cartId },
        { headers: { Authorization: `Bearer ${ambikaUserToken}` } }
      )
      .then((res) => {
        getCartDetails();
      })
      .catch((err) => {
        console.error("Error deleting product:", err);
      });
  };

  const heandelAddProduct = (el) => {
    const addQuantity = {
      UserId: ambikaUserId,
      categoryId: el?.category_id,
      CartType: el?.CartType,
      ProductId: el?.pid,
      ProductSize: el?.size_id,
      ProductPrice: el?.product_price,
      ProductQty: el?.min_qty,
      IsUrgent: el?.is_urgent,
      IsParcel: el?.is_parcel,
      EgglessOption: el?.less_cream,
      ShapOption: el?.shap_option,
      Message: el?.message,
    };
    axios
      .post(
        "https://www.erp.ambikadairyfarm.com/api/vendor/addUpdateCart",
        addQuantity,
        {
          headers: {
            Authorization: `Bearer ${ambikaUserToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        getCartDetails();
      })
      .catch((err) => {
        console.error("Error adding product:", err);
      });
  };

  const heandelMinusProduct = (el) => {
    const addQuantity = {
      UserId: ambikaUserId,
      categoryId: el?.category_id,
      CartType: el?.CartType,
      ProductId: el?.pid,
      ProductSize: el?.size_id,
      ProductPrice: el?.product_price,
      ProductQty: -el?.min_qty,
      IsUrgent: el?.is_urgent,
      IsParcel: el?.is_parcel,
      EgglessOption: el?.less_cream,
      ShapOption: el?.shap_option,
      Message: el?.message,
    };
    axios
      .post(
        "https://www.erp.ambikadairyfarm.com/api/vendor/addUpdateCart",
        addQuantity,
        {
          headers: {
            Authorization: `Bearer ${ambikaUserToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        getCartDetails();
      })
      .catch((err) => {
        console.error("Error decreasing product quantity:", err);
      });
  };

  useEffect(() => {
    axios
      .post(
        `https://www.erp.ambikadairyfarm.com/api/vendor/routeList`,
        { UserId: ambikaUserId },
        { headers: { Authorization: `Bearer ${ambikaUserToken}` } }
      )
      .then((res) => {
        setSelectRoute(res?.data?.data);
      })
      .catch((err) => {
        console.error("Error fetching route list:", err);
      });
  }, [ambikaUserId]);

  useEffect(() => {
    let sum = 0;
    for (let i = 0; i < price?.length; i++) {
      sum += price?.[i] * quantity?.[i];
    }
    setTotalPrice(sum);
  }, [quantity, price]);

  const heandelCheckNumber = () => {
    if (!checkNumber || checkNumber.length < 10) {
      setErrors({
        ...errors,
        checkNumber: "Please enter a valid 10-digit mobile number",
      });
      return;
    }

    axios
      .post(
        `https://www.erp.ambikadairyfarm.com/api/vendor/checkCustomer`,
        { Phone: checkNumber },
        { headers: { Authorization: `Bearer ${ambikaUserToken}` } }
      )
      .then((res) => {
        Swal.fire({
          text: `${res?.data?.message}`,
        });
        localStorage.setItem("ambikaCustomerId", res?.data?.data?.id);
        setAddCustomer(true);
        setAddCustomerName(res?.data?.data?.name);
        setAddCustomerButton(false);
        setErrors({ ...errors, checkNumber: "" });
        setErrors({ ...errors, addCustomerName: "" });
      })
      .catch((err) => {
        Swal.fire({
          text: `${err?.response?.data?.message}`,
        });
        setAddCustomer(true);
        setAddCustomerButton(true);
      });
  };

  const heandelAddCustomer = () => {
    if (!addCustomerName) {
      setErrors({ ...errors, addCustomerName: "Customer name is required" });
      return;
    }

    axios
      .post(
        `https://www.erp.ambikadairyfarm.com/api/vendor/addCustomer`,
        { Phone: checkNumber, Name: addCustomerName },
        { headers: { Authorization: `Bearer ${ambikaUserToken}` } }
      )
      .then((res) => {
        Swal.fire({
          text: `${res?.data?.message}`,
        });
        localStorage.setItem("ambikaCustomerId", res?.data?.CustomerId);
        setAddCustomerButton(false);
        setErrors({ ...errors, addCustomerName: "" });
      })
      .catch((err) => {
        Swal.fire({
          text: `${err?.response?.data?.message}`,
        });
      });
  };

  const postDetais = (e) => {
    const { name, value } = e.target;
    setPostData({ ...postData, [name]: value });
    // Clear error when field is filled
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  useEffect(() => {
    const addData = { ...postData };
    addData.UserId = ambikaUserId;
    addData.OrderType = userType;
    addData.CustomerId = ambikaCustomerId;
    addData.DeliveryDatetime = startDate;
    addData.RouteId = addSelectRoute;
    addData.TotalAmount = totalPrice;
    addData.PaymentType = paymentType;
    addData.CartId = cartId;
    setPostData(addData);
  }, [
    ambikaCustomerId,
    addSelectRoute,
    totalPrice,
    ambikaUserId,
    userType,
    startDate,
    paymentType,
    cartId,
  ]);

  const heandelPostData = () => {
    if (isSubmitting) return;

    if (!validateForm()) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please fill all required fields correctly",
      });
      return;
    }

    setIsSubmitting(true);

    axios
      .post(
        `https://www.erp.ambikadairyfarm.com/api/vendor/placeOrder`,
        postData,
        { headers: { Authorization: `Bearer ${ambikaUserToken}` } }
      )
      .then((res) => {
        getCartDetails();
        navigate("/placed-order");
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.response?.data?.message || "Failed to place order",
        });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handleCartUrgentAdd = (el) => {
    const addQuantity = {
      UserId: ambikaUserId,
      categoryId: el?.category_id,
      CartType: el?.CartType,
      ProductId: el?.pid,
      ProductSize: el?.size_id,
      ProductPrice: el?.product_price,
      ProductQty: 0,
      IsUrgent: el?.is_urgent,
      IsParcel: el?.is_parcel,
      EgglessOption: el?.less_cream,
      ShapOption: el?.shap_option,
      Message: el?.message,
    };
    axios
      .post(
        "https://www.erp.ambikadairyfarm.com/api/vendor/addUpdateCart",
        addQuantity,
        {
          headers: {
            Authorization: `Bearer ${ambikaUserToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        getCartDetails();
      })
      .catch((err) => {
        console.error("Error updating cart:", err);
      });
  };

  const handleCartIsUrgent = (el) => {
    const updatedEl = { ...el, is_urgent: el.is_urgent === 1 ? 0 : 1 };
    handleCartUrgentAdd(updatedEl);
  };

  const handleCartIsParcel = (el) => {
    const updatedEl = { ...el, is_parcel: el.is_parcel === 1 ? 0 : 1 };
    handleCartUrgentAdd(updatedEl);
  };

  useEffect(() => {
    const today = new Date();
    const minDate1 = today.toISOString().split("T")[0];
    const minDate2 = new Date(today.setDate(today.getDate() + 1))
      .toISOString()
      .split("T")[0];

    setMinDate(cartDataDate === "Yes" ? minDate1 : minDate2);
  }, [cartDataDate]);

  const handleDateChange = (selectedDate) => {
    if (selectedDate < minDate) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Date",
        text: "Selected date is before the allowed date. Please select a correct date!",
      });
    } else {
      setStartDate(selectedDate);
      setErrors({ ...errors, startDate: "" });

      // Get current time
      const currentDateTime = new Date();
      const hours = currentDateTime.getHours();
      const minutes = currentDateTime.getMinutes();
      const seconds = currentDateTime.getSeconds();

      // Format time in AM/PM
      const ampm = hours >= 12 ? "PM" : "AM";
      const formattedHours = hours % 12 || 12;
      const formattedMinutes = minutes?.toString()?.padStart(2, "0");
      const formattedSeconds = seconds?.toString()?.padStart(2, "0");
      const formattedTime = `${formattedHours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;

      setCurrentTime(formattedTime);
    }
  };

  useEffect(() => {
    if (branchDetails?.pickup_duration_hours && currentTime) {
      const [time, modifier] = currentTime?.split(" ");
      let [hours, formattedMinutes, formattedSeconds] = time
        ?.split(":")
        .map(Number);
      if (modifier === "PM" && hours < 12) hours += 12;
      if (modifier === "AM" && hours === 12) hours = 0;

      const totalHours =
        hours + parseInt(branchDetails?.pickup_duration_hours, 10);
      const maxHours = totalHours % 24;
      const maxAmpm = maxHours >= 12 ? "PM" : "AM";
      const formattedMaxHours = maxHours % 12 || 12;
      const formattedMaxTime = `${formattedMaxHours}:${formattedMinutes
        .toString()
        .padStart(2, "0")}:${formattedSeconds
        .toString()
        .padStart(2, "0")} ${maxAmpm}`;

      setCompleteTime(formattedMaxTime);
    }
  }, [currentTime, branchDetails]);

  const convertTimeTo24HourFormat = (timeString) => {
    if (!timeString || typeof timeString !== "string") {
      return "";
    }

    const [time, period] = timeString.split(" ");
    if (!time || !period) {
      return "";
    }

    let [hours, minutes, seconds] = time.split(":").map(Number);

    if (isNaN(hours)) hours = 0;
    if (isNaN(minutes)) minutes = 0;

    if (period === "PM" && hours !== 12) {
      hours += 12;
    } else if (period === "AM" && hours === 12) {
      hours = 0;
    }

    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  };

  const isToday = (dateString) => {
    if (!dateString) return false;
    const date = new Date(dateString);
    const today = new Date();
    date.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return date.getTime() === today.getTime();
  };

  return (
    <div>
      <div className="col-lg-6 col-md-8 col-11 m-auto">
        <div>
          <p className="fs-2 fw-sembold my-3">Order For</p>
          <div className="col-11 row  rounded-5  bg-white m-auto">
            <div
              onClick={() => setUserType("Branch")}
              style={{ cursor: "pointer" }}
              className={
                userType == "Branch"
                  ? `py-2 bg-success rounded-5 text-white ${
                      profile?.order_for_customer === 2 ? "col-12" : "col-6"
                    }`
                  : `py-2 bg-none rounded-5 text-black ${
                      profile?.order_for_customer === 2 ? "col-12" : "col-6"
                    }`
              }
            >
              <p className="fw-semibold">Self</p>
            </div>
            {profile?.order_for_customer === 1 && (
              <div
                onClick={() => setUserType("Customer")}
                style={{ cursor: "pointer" }}
                className={
                  userType == "Customer"
                    ? "col-6 py-2 bg-success rounded-5 text-white"
                    : "col-6 py-2 bg-none rounded-5 text-black"
                }
              >
                <p className="fw-semibold">Customer</p>
              </div>
            )}
          </div>
        </div>

        {cartData?.length > 0 ? (
          <div>
            <div>
              {cartData?.map((el, i) => {
                return (
                  <div
                    className="bg-white rounded-3 text-start  mt-3 boxSadow2"
                    key={i}
                  >
                    <div className="border-bottom rounded-3">
                      <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                        <div>
                          <p className="">
                            {" "}
                            <span className="fs-5 fw-semibold">
                              {el?.productName}
                            </span>{" "}
                          </p>
                          <span
                            className="text-secondary"
                            style={{ fontSize: "13px" }}
                          >
                            {" "}
                            {el?.product_price} / {el?.size_name}{" "}
                          </span>
                        </div>
                        <div>
                          <p className="fs-4 text-success fw-semibold">
                            ₹ {el?.product_qty * el?.product_price}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between  p-3">
                        <div className="d-flex gap-1">
                          {el?.product_qty <= el?.min_qty ? (
                            <button
                              className="btn btn-outline-danger p-0 px-2"
                              onClick={() => handelDeletProduct(el?.id)}
                            >
                              <i className="bi bi-trash-fill"></i>
                            </button>
                          ) : (
                            <button
                              className="btn btn-outline-danger p-0 px-2"
                              onClick={() => heandelMinusProduct(el)}
                              disabled={
                                el?.product_qty <= el?.min_qty ? true : false
                              }
                            >
                              -
                            </button>
                          )}

                          <div className="border rounded-3 p-1 px-2">
                            <p>{el?.product_qty}</p>
                          </div>
                          <button
                            className="btn btn-outline-success p-0 px-2"
                            onClick={() => heandelAddProduct(el)}
                            disabled={
                              el?.product_qty >= el?.max_qty ? true : false
                            }
                          >
                            +
                          </button>
                        </div>
                        <div className="d-flex align-items-center gap-2 ">
                          <div className="d-flex gap-2">
                            <input
                              className="form-check-input upCheckBoxInput"
                              type="checkbox"
                              checked={el?.is_urgent === 1}
                              id={`urgent${i}`}
                              onChange={() => handleCartIsUrgent(el)}
                            />
                            <label
                              className="form-check-label upCheckBox"
                              htmlFor={`urgent${i}`}
                              style={
                                el?.is_urgent === 1
                                  ? {
                                      backgroundColor: "#FF6969",
                                      color: "white",
                                      border: "1px solid #FF6969 ",
                                    }
                                  : {
                                      backgroundColor: "#F3F3F3",
                                      color: "gray",
                                      border: "1px solid gray ",
                                    }
                              }
                            >
                              U
                            </label>
                          </div>
                          <div className="d-flex gap-2">
                            <input
                              className="form-check-input upCheckBoxInput"
                              type="checkbox"
                              checked={el?.is_parcel === 1}
                              id={`parcel${i}`}
                              onChange={() => handleCartIsParcel(el)}
                            />
                            <label
                              className="form-check-label upCheckBox"
                              htmlFor={`parcel${i}`}
                              style={
                                el?.is_parcel === 1
                                  ? {
                                      backgroundColor: "#FF6969",
                                      color: "white",
                                      border: "1px solid #FF6969 ",
                                    }
                                  : {
                                      backgroundColor: "#F3F3F3",
                                      color: "gray",
                                      border: "1px solid gray ",
                                    }
                              }
                            >
                              P
                            </label>
                            {el?.less_cream && (
                              <label
                                className="form-check-label upCheckBox"
                                style={{
                                  backgroundColor: "#FF6969",
                                  color: "white",
                                  border: "1px solid #FF6969 ",
                                  width: "auto",
                                  borderRadius: "15px",
                                  padding: "5px 5px",
                                  fontSize: "12px",
                                }}
                              >
                                Less cream
                              </label>
                            )}
                          </div>
                        </div>
                      </div>
                      {(el?.shap_option || el?.message) && (
                        <div className="p-2 border-top">
                          <div className="d-flex align-items-center gap-2">
                            {el?.shap_option && <p>{el?.shap_option}</p>}
                            {el?.shap_option && el?.message && <p> | </p>}
                            {el?.message && <p> {el?.message}</p>}
                          </div>
                          {el?.photo && (
                            <div className="col-lg-4 col-6 m-auto mt-3">
                              <img
                                src={el?.photo}
                                alt=""
                                style={{ width: "100%" }}
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Customer Information Section */}
            {userType == "Customer" && (
              <div className="bg-white rounded-3 text-start mt-3 boxSadow2 p-3">
                <p className="fw-bold fs-5">Customer Information</p>
                {!addCustomer && (
                  <div className="p-2">
                    <div className="d-flex gap-2 align-items-center">
                      <div className="flex-grow-1">
                        <input
                          type="text"
                          className={`form-control border-0 ${
                            errors.checkNumber ? "is-invalid" : ""
                          }`}
                          placeholder="Mobile Number"
                          maxLength={10}
                          value={checkNumber}
                          name="Phone"
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setCheckNumber(value);
                            if (errors.checkNumber) {
                              setErrors({ ...errors, checkNumber: "" });
                            }
                          }}
                          style={{ background: "#f3f3f3" }}
                        />
                        {errors.checkNumber && (
                          <div className="invalid-feedback d-block">
                            {errors.checkNumber}
                          </div>
                        )}
                      </div>
                      <button
                        className="btn btn-success p-1 fw-semibold"
                        disabled={checkNumber?.length !== 10}
                        onClick={heandelCheckNumber}
                      >
                        Verify
                      </button>
                    </div>
                  </div>
                )}
                {addCustomer && (
                  <div className="p-2">
                    <div className="mb-3">
                      <input
                        type="text"
                        className={`form-control border-0 ${
                          errors.checkNumber ? "is-invalid" : ""
                        }`}
                        placeholder="Mobile Number"
                        maxLength={10}
                        value={checkNumber}
                        name="Phone"
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          setCheckNumber(value);
                          if (errors.checkNumber) {
                            setErrors({ ...errors, checkNumber: "" });
                          }
                        }}
                        style={{ background: "#f3f3f3" }}
                      />
                      {errors.checkNumber && (
                        <div className="invalid-feedback d-block">
                          {errors.checkNumber}
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <input
                        type="text"
                        className={`form-control border-0 ${
                          errors.addCustomerName ? "is-invalid" : ""
                        }`}
                        placeholder="Full Name"
                        value={addCustomerName}
                        name="Name"
                        onChange={(e) => {
                          setAddCustomerName(e.target.value);
                          if (errors.addCustomerName) {
                            setErrors({ ...errors, addCustomerName: "" });
                          }
                        }}
                        style={{ background: "#f3f3f3" }}
                      />
                      {errors.addCustomerName && (
                        <div className="invalid-feedback d-block">
                          {errors.addCustomerName}
                        </div>
                      )}
                    </div>
                    {addCustomerButton && (
                      <button
                        className="btn btn-success p-1 fw-semibold form-control mt-3"
                        disabled={
                          checkNumber?.length !== 10 ||
                          !addCustomerName ||
                          addCustomerName.trim() === ""
                        }
                        onClick={heandelAddCustomer}
                      >
                        Add Customer
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* Delivery Information Section */}
            <div className="bg-white rounded-3 text-start mt-3 boxSadow2 p-3">
              <div className="p-2">
                <div className="mb-3">
                  <label htmlFor="dateTime" style={{ fontSize: "12px" }}>
                    Delivery Date and Time{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <DatePicker
                    selected={startDate}
                    onChange={handleDateChange}
                    minDate={minDate}
                    dateFormat="dd-MM-yyyy"
                    className={`form-control ${
                      errors.startDate ? "is-invalid" : ""
                    }`}
                    placeholderText="Select delivery date"
                  />
                  {errors.startDate && (
                    <div className="invalid-feedback d-block">
                      {errors.startDate}
                    </div>
                  )}
                </div>

                <div className="mb-3">
                  <label htmlFor="selectRoute" style={{ fontSize: "12px" }}>
                    Select Route <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select border-0 bg-body-secondary ${
                      errors.addSelectRoute ? "is-invalid" : ""
                    }`}
                    aria-label="Default select example"
                    disabled={!completeTime}
                    value={addSelectRoute}
                    onChange={(e) => {
                      setAddSelectRoute(e.target.value);
                      if (errors.addSelectRoute) {
                        setErrors({ ...errors, addSelectRoute: "" });
                      }
                    }}
                  >
                    <option value="">Select Route</option>
                    {isToday(startDate)
                      ? selectRoute?.map((el) => {
                          return (
                            convertTimeTo24HourFormat(completeTime) <
                              convertTimeTo24HourFormat(
                                el?.route_start_time
                              ) && (
                              <option value={el?.id} key={el?.id}>
                                {el?.name}
                              </option>
                            )
                          );
                        })
                      : selectRoute?.map((el) => {
                          return (
                            <option value={el?.id} key={el?.id}>
                              {el?.name}
                            </option>
                          );
                        })}
                  </select>
                  {errors.addSelectRoute && (
                    <div className="invalid-feedback d-block">
                      {errors.addSelectRoute}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label htmlFor="orderRemarks" style={{ fontSize: "12px" }}>
                    Order Remarks
                  </label>
                  <input
                    type="text"
                    className={`form-control border-0 ${
                      errors.deliveryInstruction ? "is-invalid" : ""
                    }`}
                    id="orderRemarks"
                    placeholder="Order Remarks"
                    value={postData?.DeliveryInstruction || ""}
                    name="DeliveryInstruction"
                    onChange={(e) => {
                      postDetais(e);
                    }}
                    style={{ background: "#f3f3f3" }}
                  />
                </div>
                {/* <div className="mb-3">
                  <label htmlFor="orderRemarks" style={{ fontSize: "12px" }}>
                    Order Remarks <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control border-0 ${
                      errors.deliveryInstruction ? "is-invalid" : ""
                    }`}
                    id="orderRemarks"
                    placeholder="Order Remarks"
                    value={postData?.DeliveryInstruction || ""}
                    name="DeliveryInstruction"
                    onChange={(e) => {
                      postDetais(e);
                      if (errors.DeliveryInstruction) {
                        setErrors({ ...errors, DeliveryInstruction: "" });
                      }
                    }}
                    style={{ background: "#f3f3f3" }}
                  />
                  {errors.deliveryInstruction && (
                    <div className="invalid-feedback d-block">
                      {errors.deliveryInstruction}
                    </div>
                  )}
                </div> */}
              </div>
            </div>

            {/* Payment Details Section */}
            <div className="bg-white rounded-3 text-start mt-3 boxSadow2 p-3">
              <p className="fw-bold fs-5">
                Order Payment Details ({cartData?.length} items)
              </p>
              <div className="p-2">
                <div className="d-flex align-items-center justify-content-between mt-1">
                  <p className="fs-5">Total Amount:</p>
                  <p className="fs-3 fw-bold text-success"> ₹ {totalPrice}</p>
                </div>
                {userType == "Customer" && (
                  <div>
                    <div className="mb-3">
                      <label htmlFor="paidAmount" style={{ fontSize: "12px" }}>
                        Paid Amount <span className="text-danger">*</span>
                        {profile?.advance_order_amount_percentage && parseFloat(profile?.advance_order_amount_percentage) > 0 ? (
                          <span className="text-muted ms-1">
                            (Min: {parseFloat(profile?.advance_order_amount_percentage)}%)
                          </span>
                        ) : null}
                      </label>
                      <input
                        type="number"
                        className={`form-control border-0 ${
                          errors.paidAmount ? "is-invalid" : ""
                        }`}
                        id="paidAmount"
                        placeholder="Paid Amount"
                        min={
                          profile?.advance_order_amount_percentage && parseFloat(profile?.advance_order_amount_percentage) > 0
                            ? (totalPrice * parseFloat(profile?.advance_order_amount_percentage)) / 100
                            : "0"
                        }
                        max={totalPrice}
                        value={postData?.PaidAmount !== undefined && postData?.PaidAmount !== "" ? postData?.PaidAmount : ""}
                        name="PaidAmount"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const value = inputValue === "" ? "" : Math.min(Number(inputValue), totalPrice);
                          postDetais({ target: { name: "PaidAmount", value } });
                          if (errors.paidAmount) {
                            setErrors({ ...errors, paidAmount: "" });
                          }
                        }}
                        style={{ background: "#f3f3f3" }}
                      />
                      {errors.paidAmount && (
                        <div className="invalid-feedback d-block">
                          {errors.paidAmount}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label
                        htmlFor="remainingAmount"
                        style={{ fontSize: "12px" }}
                      >
                        Remaining Amount <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control border-0"
                        id="remainingAmount"
                        placeholder="Remaining Amount"
                        value={
                          postData?.PaidAmount
                            ? totalPrice - postData?.PaidAmount
                            : totalPrice
                        }
                        readOnly
                        style={{ background: "#f3f3f3" }}
                      />
                    </div>

                    <div className="mb-3">
                      <label
                        htmlFor="paymentRemark"
                        style={{ fontSize: "12px" }}
                      >
                        Payment Remark <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control border-0 ${
                          errors.paymentRemarks ? "is-invalid" : ""
                        }`}
                        id="paymentRemark"
                        placeholder="Payment Remark"
                        value={postData?.PaymentRemarks || ""}
                        name="PaymentRemarks"
                        onChange={(e) => {
                          postDetais(e);
                          if (errors.paymentRemarks) {
                            setErrors({ ...errors, paymentRemarks: "" });
                          }
                        }}
                        style={{ background: "#f3f3f3" }}
                      />
                      {errors.paymentRemarks && (
                        <div className="invalid-feedback d-block">
                          {errors.paymentRemarks}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <p className="fs-5 fw-semibold">
                        Payment Mode <span className="text-danger">*</span>
                      </p>
                      <div className="d-flex align-content-center gap-2 flex-wrap">
                        {profile?.is_cash == 1 && (
                          <div
                            className="d-flex gap-1 align-items-center"
                            onClick={() => {
                              setPaymentType("cash");
                              setErrors({ ...errors, paymentType: "" });
                            }}
                          >
                            <input
                              type="radio"
                              className="form-check text-success"
                              id="cash"
                              checked={paymentType === "cash"}
                              readOnly
                            />
                            <label htmlFor="cash">Cash</label>
                          </div>
                        )}
                        {profile?.is_card == 1 && (
                          <div
                            className="d-flex gap-1 align-items-center"
                            onClick={() => {
                              setPaymentType("card");
                              setErrors({ ...errors, paymentType: "" });
                            }}
                          >
                            <input
                              type="radio"
                              className="form-check text-success"
                              id="card"
                              checked={paymentType === "card"}
                              readOnly
                            />
                            <label htmlFor="card">Card</label>
                          </div>
                        )}

                        {profile?.is_paytm == 1 && (
                          <div
                            className="d-flex gap-1 align-items-center"
                            onClick={() => {
                              setPaymentType("paytm");
                              setErrors({ ...errors, paymentType: "" });
                            }}
                          >
                            <input
                              type="radio"
                              className="form-check text-success"
                              id="paytm"
                              checked={paymentType === "paytm"}
                              readOnly
                            />
                            <label htmlFor="paytm">Paytm</label>
                          </div>
                        )}

                        {profile?.is_sodexo == 1 && (
                          <div
                            className="d-flex gap-1 align-items-center"
                            onClick={() => {
                              setPaymentType("sodexo");
                              setErrors({ ...errors, paymentType: "" });
                            }}
                          >
                            <input
                              type="radio"
                              className="form-check text-success"
                              id="sodexo"
                              checked={paymentType === "sodexo"}
                              readOnly
                            />
                            <label htmlFor="sodexo">Sodexo</label>
                          </div>
                        )}
                        {profile?.is_due_payment == 1 && (
                          <div
                            className="d-flex gap-1 align-items-center"
                            onClick={() => {
                              setPaymentType("duePayment");
                              setErrors({ ...errors, paymentType: "" });
                            }}
                          >
                            <input
                              type="radio"
                              className="form-check text-success"
                              id="duePayment"
                              checked={paymentType === "duePayment"}
                              readOnly
                            />
                            <label htmlFor="duePayment">Due Payment</label>
                          </div>
                        )}
                      </div>
                      {errors.paymentType && (
                        <div className="invalid-feedback d-block">
                          {errors.paymentType}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <button
              className={`btn btn-success form-control mt-3 rounded-5 ${
                isSubmitting ? "disabled" : ""
              }`}
              onClick={heandelPostData}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Placing Order..." : "Place Order"}
            </button>
            <br />
          </div>
        ) : (
          <div>
            <p className="fs-1 fw-semibold my-5">
              Cart is empty. Please select a product.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddTocart;
